import { render, staticRenderFns } from "./serviceRecord.vue?vue&type=template&id=cdf52372&"
import script from "./serviceRecord.vue?vue&type=script&lang=js&"
export * from "./serviceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports